"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsSales = void 0;
const statsSalesGetLocalAuthorityAverageTimeOnMarketStatsSalesLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet_js_1 = require("../funcs/statsSalesGetLocalAuthorityAverageTimeOnMarketStatsSalesLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet.js");
const statsSalesGetLocalAuthorityEstimatedValuesStatsSalesLocalAuthorityEstimatedValuesLocalAuthorityCodeGet_js_1 = require("../funcs/statsSalesGetLocalAuthorityEstimatedValuesStatsSalesLocalAuthorityEstimatedValuesLocalAuthorityCodeGet.js");
const statsSalesGetLocalAuthorityPricePerSquareFootStatsSalesLocalAuthorityAveragePricePerSquareFootLocalAuthorityCodeGet_js_1 = require("../funcs/statsSalesGetLocalAuthorityPricePerSquareFootStatsSalesLocalAuthorityAveragePricePerSquareFootLocalAuthorityCodeGet.js");
const statsSalesGetLocalAuthorityPropertiesSoldStatsSalesLocalAuthorityPropertiesSoldLocalAuthorityCodeGet_js_1 = require("../funcs/statsSalesGetLocalAuthorityPropertiesSoldStatsSalesLocalAuthorityPropertiesSoldLocalAuthorityCodeGet.js");
const statsSalesGetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGet_js_1 = require("../funcs/statsSalesGetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGet.js");
const statsSalesGetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGet_js_1 = require("../funcs/statsSalesGetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGet.js");
const statsSalesGetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGet_js_1 = require("../funcs/statsSalesGetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGet.js");
const statsSalesGetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGet_js_1 = require("../funcs/statsSalesGetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class StatsSales extends sdks_js_1.ClientSDK {
    /**
     * Local Authority - Average Time On Market
     *
     * @remarks
     * Calculate the average time a property was on the market (Available) for properties in a local authority.
     *
     * - Average by each property type.
     * - Average across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLocalAuthorityAverageTimeOnMarketStatsSalesLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetLocalAuthorityAverageTimeOnMarketStatsSalesLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet_js_1.statsSalesGetLocalAuthorityAverageTimeOnMarketStatsSalesLocalAuthorityAverageTimeOnMarketLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * Local Authority - Estimated Values
     *
     * @remarks
     * Calculate the estimated values for all properties in a local authority.
     *
     * - Average by month across all property types.
     * - Average by month split by property type.
     * - Delta increases/decreases in price over the time period.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLocalAuthorityEstimatedValuesStatsSalesLocalAuthorityEstimatedValuesLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetLocalAuthorityEstimatedValuesStatsSalesLocalAuthorityEstimatedValuesLocalAuthorityCodeGet_js_1.statsSalesGetLocalAuthorityEstimatedValuesStatsSalesLocalAuthorityEstimatedValuesLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * Local Authority - Average Price Per Square Foot
     *
     * @remarks
     * Calculate the average price per square foot for properties in a local authority.
     *
     * - Average by each property type.
     * - Average across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLocalAuthorityPricePerSquareFootStatsSalesLocalAuthorityAveragePricePerSquareFootLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetLocalAuthorityPricePerSquareFootStatsSalesLocalAuthorityAveragePricePerSquareFootLocalAuthorityCodeGet_js_1.statsSalesGetLocalAuthorityPricePerSquareFootStatsSalesLocalAuthorityAveragePricePerSquareFootLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * Local Authority - Properties Sold
     *
     * @remarks
     * Calculate the total properties sold in a local authority.
     *
     * - Total by each property type.
     * - Total across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getLocalAuthorityPropertiesSoldStatsSalesLocalAuthorityPropertiesSoldLocalAuthorityCodeGet(security, localAuthorityCode, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetLocalAuthorityPropertiesSoldStatsSalesLocalAuthorityPropertiesSoldLocalAuthorityCodeGet_js_1.statsSalesGetLocalAuthorityPropertiesSoldStatsSalesLocalAuthorityPropertiesSoldLocalAuthorityCodeGet)(this, security, localAuthorityCode, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Average Time On Market
     *
     * @remarks
     * Calculate the national average time a property was on the market (Available) for all properties.
     *
     * - Average by each property type.
     * - Average across all property types nationally.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGet_js_1.statsSalesGetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGet)(this, security, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Estimated Values
     *
     * @remarks
     * Calculate the national estimated values for all properties.
     *
     * - Average by month across all property types.
     * - Average by month split by property type.
     * - Delta increases/decreases in price over the time period.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getNationalEstimatedValuesStatsSalesNationalEstimatedValuesGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGet_js_1.statsSalesGetNationalEstimatedValuesStatsSalesNationalEstimatedValuesGet)(this, security, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Average Price Per Square Foot
     *
     * @remarks
     * Calculate the national average price per square foot for properties.
     *
     * - Average by each property type.
     * - Average across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGet_js_1.statsSalesGetNationalPricePerSquareFootStatsSalesNationalAveragePricePerSquareFootGet)(this, security, filterEndDate, filterStartDate, options));
    }
    /**
     * National - Properties Sold
     *
     * @remarks
     * Calculate the national total properties sold.
     *
     * - Total by each property type.
     * - Total across all property types.
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/kraken/api_documentation/user_guide.html#time-snapping) for more information on using time snapping.
     * </details>
     */
    async getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGet(security, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsSalesGetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGet_js_1.statsSalesGetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGet)(this, security, filterEndDate, filterStartDate, options));
    }
}
exports.StatsSales = StatsSales;
//# sourceMappingURL=statssales.js.map